/* eslint-disable camelcase */
import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { selectRoomFromUrlExpiryEvent } from 'ducks/chat/selectors/rooms'

export default function useExpiryEvent(event) {
  const expiryEventFromUrl = useSelector(selectRoomFromUrlExpiryEvent)
  const expiryEvent = event || expiryEventFromUrl
  const [remainingMins, setRemainingMins] = useState()
  const intervalRef = useRef()
  const remainingMinsRef = useRef()

  const intervalCallback = mins => {
    if (remainingMinsRef.current > mins) {
      const diff = remainingMinsRef.current - mins
      remainingMinsRef.current = diff
      setRemainingMins(diff)
    }
    // eslint-disable-next-line no-use-before-define
    recomputeIntervals()
  }

  const recomputeIntervals = () => {
    let intervalId = null
    const mins = remainingMinsRef.current

    if (mins > 60) {
      // update every hour
      intervalId = setInterval(() => intervalCallback(60), 60 * 60 * 1000)
    } else if (mins > 15) {
      // update every 15 mins
      intervalId = setInterval(() => intervalCallback(15), 15 * 60 * 1000)
    } else if (mins > 1 && mins <= 15) {
      // update every 1 min
      intervalId = setInterval(() => intervalCallback(1), 60 * 1000)
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
      remainingMinsRef.current = 0
      setRemainingMins(0)
    }

    if (intervalId) {
      // clear old one before assigning a new
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
      intervalRef.current = intervalId
    }
  }

  useEffect(
    () => {
      if (!expiryEvent) return

      const { expires_at } = expiryEvent
      const currentTimeMs = new Date().getTime()
      const diff = (expires_at - currentTimeMs) / 1000 / 60

      remainingMinsRef.current = diff
      setRemainingMins(diff)
      recomputeIntervals()

      // eslint-disable-next-line consistent-return
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current)
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [expiryEvent]
  )

  return { isExpirable: !!expiryEvent?.expires_at, remainingMins }
}
